<template>
    <div class="virtual">
        <div
            v-if="isLoading"
            class="spinner-container"
        >
            <SpinnerBars/>
        </div>
        <Game
            v-if="isGameFound"
            :gameSlug="gameSlug"
            :sessionId="sessionId"
            :balance="userBalanceWithBonus"
            :isMobile="isMobile"
            v-bind="game"
            @loginRequired="setModal(Modals.login.code)"
            @insufficientFunds="$router.push(link.deposit)"
            @contentLoaded="onLoaded"
            @ticketResolved="getBalance"
        />
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import { links } from '@app/router';
    import Modals from '@store/modules/ui/shared/modal/modals';
    import { errorGuard } from '@app/utils';
    import Game from './components/Game.vue';

    export default {
        name: 'VirtualGameDetailContainer',
        data() {
            return {
                isLoading: true,
            };
        },
        async created() {
            this.Modals = Modals;

            await errorGuard({
                action: async () => {
                    if (this.virtualGames.length === 0) {
                        await this.fetchAllGames();
                    }

                    if (!this.isGameFound) {
                        this.redirectToCategories();
                    }
                },
            });
        },
        watch: {
            '$route.params.virtualNameSlug': function () {
                this.isLoading = true;
            }
        },
        computed: {
            ...mapGetters('data/games', [
                'virtualGames',
            ]),
            ...mapGetters('data/authentication', [
                'user',
                'userBalanceWithBonus',
            ]),
            ...mapGetters('ui/deviceInfo', [
                'isMobile',
            ]),
            gameSlug() {
                return this.$route.params.virtualNameSlug;
            },
            game() {
                return this.virtualGames.filter((game) => game.redirectUrl.endsWith((this.gameSlug)))[0];
            },
            isGameFound() {
                return !!this.game;
            },
            sessionId() {
                if (!this.user) {
                    return null;
                }
                return this.user.sessionId;
            },
        },
        methods: {
            ...mapActions('ui/modal', [
                'setModal',
            ]),
            ...mapActions('data/games', [
                'fetchAllGames',
            ]),
            ...mapActions('ui/user/account', [
                'getBalance',
            ]),
            redirectToCategories() {
                this.$router.push(links.virtual);
            },
            onLoaded() {
                this.isLoading = false;
            }
        },
        components: {
            Game,
        },
    };
</script>



// WEBPACK FOOTER //
// src/app/modules/games/virtuals/VirtualGameDetailContainer.vue